export default "__VITE_ASSET__CVLER5s8__"